module.exports = __webpack_public_path__ + "static/media/web_dev.82e4c575.png";